import {
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LabelList,
  ResponsiveContainer
} from "recharts";
import { useState, useEffect } from "react";
import "./Charts.css";
import { handleClickLogic } from "../../utils/filterFunctions";

const StackedBarChartComparison = ({ showData, xKey, title, selectedKey, frozenKey, onBarClick, colors = ['#00BFFF', '#FFA500'] }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isFrozen, setIsFrozen] = useState(false);
  const [frozenData, setFrozenData] = useState(null);

  const dataToRender = isFrozen ? frozenData : showData;

  useEffect(() => {
    setSelectedCategory(selectedKey);
  }, [selectedKey]);

  useEffect(() => {
    if (frozenKey !== title) {
      setIsFrozen(false);
      setFrozenData(null);
    }
  }, [frozenKey, title]);

  const hasData = Array.isArray(dataToRender) && dataToRender.length > 0;

  if (!hasData) {
    return (
      <div className="chart-card">
        <h3>{title}</h3>
        <div className="chart-body empty">
          <p style={{ textAlign: "center", color: "#888", margin: "20px 0" }}>
            Sin datos disponibles
          </p>
        </div>
      </div>
    );
  }

  const barKeys = Object.keys(dataToRender[0]).filter(key => key !== xKey);

  const handleBarClick = (data) => {
    handleClickLogic({
      data,
      xKey,
      selectedCategory,
      isFrozen,
      showData,
      setIsFrozen,
      setFrozenData,
      setSelectedCategory,
      onBarClick,
    });
  };

  const labelFormatter = (value) => {
    return value === 0 ? '' : value;
  };

  return (
    <div className="chart-card">
      <h3>{title}</h3>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={dataToRender}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey={xKey}
          />
          <YAxis />
          <Tooltip />
          <Legend />
          {barKeys.map((key, index) => (
            <Bar
              key={key}
              dataKey={key}
              fill={colors[index % colors.length]}
              stackId="stack"
              onClick={handleBarClick}
              shape={(props) => {
                const category = props.payload?.[xKey];
                const isSelected = selectedCategory === category;
                const opacity = isFrozen
                  ? selectedCategory && !isSelected ? 0.4 : 1
                  : 1;
                const stroke = isFrozen && isSelected ? "#333" : "none";
                const strokeWidth = isFrozen && isSelected ? 2 : 0;
                return (
                  <Rectangle
                    {...props}
                    fillOpacity={opacity}
                    stroke={stroke}
                    strokeWidth={strokeWidth}
                    cursor="pointer"
                  />
                );
              }}>
              <LabelList dataKey={key} position="inside" formatter={labelFormatter}/>
            </Bar>
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default StackedBarChartComparison;